export default "__VITE_ASSET__5f65ad9c__"